import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetSentEmailLogsService } from './get-sent-email-logs/get-sent-email-logs.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    GetSentEmailLogsService
  ],
})
export class SentEmailLogsModule {}
